import { Grid } from '@material-ui/core'
import React from 'react'
import BasicNavbar from '../BasicNavbar'
import { withStyles } from "@material-ui/core/styles";
import { styled } from "@mui/material/styles";
import AuthenticationStyle from "../../Styles/AuthenticationStyle";
import BottomNav from '../BottomNav'
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Paper from '@mui/material/Paper';
import { Button, FormControl, InputGroup } from 'react-bootstrap';
import { Input, InputAdornment } from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import KeyIcon from '@mui/icons-material/Key';
import TwitterIcon from '@mui/icons-material/Twitter';
import GoogleIcon from '@mui/icons-material/Google';
import FacebookIcon from '@mui/icons-material/Facebook';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { Link, useNavigate } from 'react-router-dom';
import SendIcon from '@mui/icons-material/Send';
import Allservices from './Allservices';
import AllservicesModify from '../Navigation/ModifyPage.jsx/AllservicesModify';
import Services from '../Homepage/Services';
import Flow from '../Homepage/Flow';
import Purpose from '../Homepage/Purpose';
import AskedQuestions from '../Homepage/AskedQuestions';
import Footer from '../Homepage/Footer';
import BottomNav2 from '../BottomNav2';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Backdrop from "@mui/material/Backdrop";
import draftId from '../AllService';
import { getBaseURL } from '../../api/apiManagement';
const ImgGrid = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down("xl")]: {
    // marginLeft: "20px",
    //  marginTop: "5px"
  },
  [theme.breakpoints.down("md")]: {
    marginLeft: "40px",
    display: 'flex',
    justifyContent: 'center',
  },
}));
const Image = styled('img')(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    maxWidth: "600px"
  },
  [theme.breakpoints.down("md")]: {
    maxWidth: "300px",

  },
}));

const ServiceOptions =(props) => {

  const { classes } = props;
  const navigate = useNavigate();
  const [openError,setOpenError] = React.useState(false)
const [error,setError] = React.useState('')
  const handleCloseError = ()=>{
    setOpenError(false)
  }

  function gotoDashboard(){
   
    navigate('/dashboard')
   
  }

  function gotoSendPackage(){
    draftId.value = "";
    navigate('/sendpackage')
    // if(localStorage.getItem("released") === "true"){
  
    // }
    // else{
    //   setOpenError(true)
    // }
  }
  function gotoCollectPackage(){
    draftId.value = "";
    if(localStorage.getItem("released") === "true"){
    navigate('/collectpackage')
    }
    else{
      setOpenError(true)
    }
  }
  function gotoConsularPackage(){
    draftId.value = "";
    navigate('/consularpackage')
  }
  function gotoPhoto(){
    if(localStorage.getItem("released") === "true"){
    navigate('/photoservice')
    }
    else{
      setOpenError(true)
    }
  }
  function gotoAccompainment(){
    if(localStorage.getItem("released") === "true"){
    navigate('/accompainment')
    }
    else{
      setOpenError(true)
    }
  }
  function gotoDocument(){
    if(localStorage.getItem("released") === "true"){
   navigate('/documentAttestation')
    }
    else{
      setOpenError(true)
    }
   //navigate('/commingsoon')
  }
  function gotoPersonel(){
    if(localStorage.getItem("released") === "true"){
    navigate('/personelised')
    }
    else{
      setOpenError(true)
    }
  }
  function gotoTrack(){
    if(localStorage.getItem("released") === "true"){
    navigate('/trackorder')
    }
    else{
      setOpenError(true)
    }
  }
  React.useEffect(() => {

    setError(localStorage.getItem("error"))
 


}, []);
  return (<>
  {/* <BasicNavbar/> */}
  <Allservices/>
  {/* <AllservicesModify/> */}
  {/* <Grid container> 



<Grid item xs={12} md={12} lg={12} sm={12} className="location">
 <Grid container className={classes.ht}  >

   <div className={classes.location}>
     <p className='location-text'>
       <span className={classes.ht}>
         <div className='flexed'>
           <LocationOnIcon className={classes.locIcon}></LocationOnIcon> <span>United Arab Emirates</span>
         </div>

       </span>
     </p>
   </div>
 </Grid>
</Grid> </Grid> */}
    <Grid container className={classes.coperate_start2}>
   
    <Grid container className={classes.ht}  >
  
        {/* <Grid item xs={6} md={6} lg={6} className={classes.allm}>
            <img className={classes.service_bg} src='./Images/nav.png'></img>
        </Grid> */}
         <ImgGrid item xs={12} md={6} lg={6} >
         {/* <img className='background-1' src='./Images/nav.png'></img> */}
         <img className={classes.service_bg} src='./Images/nav.png'></img>
       {/* <Image src='./Images/nav.png' alt="bg" className='background-2' style={{marginLeft: "45px"}}>
       </Image> */}
        
       </ImgGrid>
         <Grid item xs={12} md={4} lg={4} className={classes.allm}>
         
          <div ><b className={classes.services_coperate_btn}>Corporate Login</b></div>
            <div  className='welcome7' style={{marginBottom:"0px"}}>Welcome</div><br/>
           <div className='contents' style={{marginBottom:"10px"}}>Kindly select from our services</div> 
           
            <div className={classes.Allservice}>
            
              <Button variant="contained" className={classes.service_btn} onClick={()=>gotoSendPackage()}><b>Send package</b><img className={classes.service_image} src='./Images/arrow-right-small.png'></img></Button>
              <Button variant="contained" className={classes.service_btn} onClick={()=>gotoCollectPackage()}><b>Collect package</b><img className={classes.service_image} src='./Images/arrow-right-small.png'></img></Button>
              {localStorage.getItem('previlage') === 'jiffyadmin' ?(
              <Button variant="contained" className={classes.service_btn} onClick={()=>gotoConsularPackage()}>
                <b>Consular Liaison</b>
                <span
                  style={{
                    marginLeft: "6px",
                    backgroundColor: "#FFA500",
                    background: "linear-gradient(135deg, #FFA500 0%, #FF8C00 100%)",
                    color: "#FFFFFF",
                    fontSize: "10px",
                    fontWeight: "700",
                    padding: "4px 10px",
                    borderRadius: "12px",
                    textTransform: "uppercase",
                    letterSpacing: "0.8px",
                    fontFamily: "Montserrat",
                    boxShadow: "0 2px 4px rgba(255, 165, 0, 0.3)",
                    display: "inline-flex",
                    alignItems: "center",
                    lineHeight: "1",
                  }}
                >
                  New
                </span>
                <img className={classes.service_image} src='./Images/arrow-right-small.png'></img>
              </Button>):(<></>)}
             <Button variant="secondary" className={classes.service_btn} onClick={()=>gotoAccompainment()}><b>Accompaniment</b><img className={classes.service_image} src='./Images/arrow-right-small.png'></img></Button>
              <Button variant="secondary" className={classes.service_btn} onClick={()=>gotoDocument()}><b>Document Attestation - MOFA</b><img className={classes.service_image} src='./Images/arrow-right-small.png'></img></Button>
              <Button variant="secondary" className={classes.service_btn} onClick={()=>gotoPersonel()}><b>Personalized Services</b><img className={classes.service_image} src='./Images/arrow-right-small.png'></img></Button>
              <Button variant="secondary" className={classes.service_btn} onClick={()=>gotoPhoto()}><b> Digital Photo Service</b><img className={classes.service_image} src='./Images/arrow-right-small.png'></img></Button>
            {/* --> <Button variant="secondary" className={classes.service_btn} onClick={()=>goto()}><b>Others</b><img className={classes.service_image} src='./Images/arrow-right-small.png'></img></Button> */}
              <Grid container className='dashDetails'>
              <Grid item xs={6} md={6} lg={6}>
              <Button fullWidth variant="secondary" className={classes.btn_dash} onClick={()=>gotoDashboard()}><b>Dashboard</b>&nbsp;<img  src='./Images/dash.svg'></img><img className={classes.service_img_dash} src='./Images/dashed.png'></img></Button>
              </Grid>
              <Grid item xs={6} md={6} lg={6}>
             <div className={classes.para_dash}> View todays order, orders completed, average time spent & more</div>
              </Grid>
              </Grid>
            {/* --> <Button variant="secondary" className={classes.service_btn} onClick={()=>gotoTrack()}><b>Track</b><img className={classes.service_image} src='./Images/arrow-right-small.png'></img></Button> */}
            </div>  
        </Grid>
        </Grid>
        <Grid item xs={4} md={4} lg={4}
        >
        </Grid> 
        <Grid item xs={4} md={4} lg={4}
        >


</Grid>
    </Grid>
    <Services></Services>
    <Flow></Flow>
    <Purpose></Purpose>
    <AskedQuestions></AskedQuestions>
    <Footer></Footer>
    <BottomNav2/>
    <Dialog
        open={openError}
        onClose={() => handleCloseError()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "500px",
            },
          },
        }}
      >
        <DialogTitle id="alert-dialog-title">{"Jiffy Alert"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {localStorage.getItem("error")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleCloseError()} autoFocus className='popup'>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    
    </>
  )
}
export default withStyles(AuthenticationStyle)(ServiceOptions);
